<!-- Translated: yes -->
<template>
  <div :class="'SwitchButton '+ (icon ? 'has-icon' : 'no-icon')" :style="componentStyle">
    <span v-if="icon" class="icon"><icon :name="icon" :scale="iconscale"></icon></span>
    <span class="label" v-if="labelPosition === 'before' && toggled">{{labelChecked}}</span>
    <span class="label" v-if="labelPosition === 'before' && !toggled">{{labelUnchecked}}</span>
    <span class="label" v-if="labelPosition === 'after'" style="float:right;line-height:26px;margin-left:10px;text-transform:none;">{{labelChecked}}</span>
    <label class="vue-js-switch" :class="{toggled, disabled}">
      <input type="checkbox" class="v-switch-input" @change.stop="toggle">
      <span class="v-switch-core" :style="coreStyle"></span>
      <!-- <div v-if="labels">
        <span class="v-switch-label v-left" v-if="toggled">{{labelChecked}}</span>
        <span class="v-switch-label v-right" v-else>{{labelUnchecked}}</span>
      </div> -->
    </label>
    <div style="clear:both;"></div>
  </div>
</template>

<script>
const DEF_CHECKED_COLOR = '#43a46b';
const DEF_UNCHECKED_COLOR = '#ecf5f8';

const DEF_CHECKED_LABEL = 'on';
const DEF_UNCHECKED_LABEL = 'off';

const CORE_SIZE = 22;
// 11/25 = -.44
/* eslint-disable */
const DEFAULT_HEIGHT = 13;
const DEFAULT_WIDTH = 35;
const objectHas = (object, title) => typeof object === 'object' && object.hasOwnProperty(title);

export default {
  name: 'ToggleButton',
  props: {
    store: {
      type: String,
    },
    icon: {
      type: String,
      default: '',
    },
    iconscale: {
      type: Number,
      default: 1,
    },
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    sync: {
      type: Boolean,
      default: false,
    },
    scale: {
      type: Number,
      default: 1,
    },
    color: {
      type: [String, Object],
      validator(value) {
        if (typeof value === 'object') {
          return value.checked || value.unchecked;
        }

        return typeof value === 'string';
      },
    },
    labels: {
      type: [Boolean, Object],
      default: false,
      validator(value) {
        if (typeof value === 'object') {
          return value.checked || value.unchecked;
        }

        return typeof value === 'boolean';
      },
    },
    labelPosition: {
      default: 'before',
    },
    width: {
      type: Number,
      default: DEFAULT_WIDTH,
    },
  },
  computed: {
    colorChecked() {
      if (typeof this.color !== 'object') {
        return this.color || DEF_CHECKED_COLOR;
      }

      return objectHas(this.color, 'checked')
        ? this.color.checked
        : DEF_CHECKED_COLOR;
    },

    colorUnchecked() {
      return objectHas(this.color, 'unchecked')
        ? this.color.unchecked
        : DEF_UNCHECKED_COLOR;
    },

    colorCurrent() {
      return this.toggled ? this.colorChecked : this.colorUnchecked;
    },

    labelChecked() {
      return objectHas(this.labels, 'checked')
        ? this.labels.checked
        : DEF_CHECKED_LABEL;
    },

    labelUnchecked() {
      return objectHas(this.labels, 'unchecked')
        ? this.labels.unchecked
        : DEF_UNCHECKED_LABEL;
    },

    coreStyle() {
      return {
        'background-color': this.colorCurrent,
        // 'border-color': this.colorCurrent,
        '--toggle-width': `${this.width}px`,
        '--toggle-transform-distance': `${this.width - CORE_SIZE}px`,
      };
    },

    componentStyle() {
      return {
        'transform': `scale(${this.scale})`,
      };
    },
  },
  watch: {
    value(value) {
      if (this.sync) {
        this.toggled = value;
      }
    },
  },
  data() {
    return {
      toggled: this.value,
    };
  },
  methods: {
    toggle(event) {
      this.toggled = !this.toggled;
      this.$emit('toggle', {key: this.store, 'value': this.toggled});
    },
  },
};
</script>

<style lang="stylus" scoped>



.SwitchButton
  background-color white
  border-radius 4px
  padding 9px 13px 8px 13px;
  border 1px solid rgba(191 217 225, 0.7)
  .label
    font-family Interstate
    font-size 10px
    font-weight bold
    letter-spacing 0.3px
    color #262626
    text-transform uppercase
  &.no-icon
    .label
      padding-top 5px
      display: inline-block;
.vue-js-switch
  float right
  display inline-block
  position relative
  overflow hidden
  vertical-align middle
  user-select none

  cursor pointer

  line-height 22px
  height 25px
  margin-left 15px

  .v-switch-input
    display none

  .v-switch-label
    position absolute
    top 0
    font-size 10px
    font-weight 600
    line-height 22px
    height 22px
    color white

    &.v-left
      left 10px

    &.v-right
      right 10px

  .v-switch-core
    margin 0
    display inline-block
    position relative
    border 1px solid #bfcbd9
    outline 0
    border-radius 12px
    box-sizing border-box
    background #bfcbd9
    transition border-color .3s, background-color .3s
    user-select none
    position: relative;
    top: 3px;

    width 50px
    width 36px
    height 20px

    &:before
      display block
      content ''

      transform translate(-1px, -1px)

      top -1px
      left 0
      position absolute
      border-radius 100%
      transition transform .3s
      width 20px
      height 20px
      // z-index 20
      background-color #fff
      border: 1px solid rgba(0, 85, 128, 0.85)

  &.toggled
    .v-switch-core
      &:before
        transform translate(16px, 0px)
        transform translate(var(--toggle-transform-distance), -1px)
        background-image: url(https://static.booking.branasgruppen.se/static/svg/check-round-green.svg)
        background-size contain
        background-repeat no-repeat
        border-color #43a46b

  &.disabled
    pointer-events none
    cursor not-allowed
    opacity 0.6

.icon
  padding-right .5rem
  svg
    vertical-align middle
</style>



// WEBPACK FOOTER //
// SwitchButton.vue?601d6162